import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { loadLogAccordingToLogId, loadLogAccordingToCorrelationId } from "../actionCreators";
import { bindActionCreators } from "redux";
import ItemDetailsComponent from "./ItemDetailsComponent";
import { useLocation, useHistory, useParams } from "react-router";

const DetailsContainer = ({ log, actions }) => {
  const params = useParams();
  const location = useLocation();
  const history = useHistory();

  const { keyId } = params;
  const [loading, setLoading] = useState(location.state && location.state.reload);
  const timer = React.useRef();

  if (location.state && location.state.reload) {
    timer.current = setTimeout(() => {
      setLoading(false);
      const state = { ...location.state };
      delete state.reload;
      history.push(location.pathname, { replace: true });
    }, 4000);
  }

  useEffect(() => {
    actions.loadLogAccordingToLogId(keyId);
    return () => clearTimeout(timer.current);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!loading) {
      actions.loadLogAccordingToLogId(keyId);
    }
  }, [loading]); // eslint-disable-line react-hooks/exhaustive-deps

  return <ItemDetailsComponent item={log} loading={loading} />;
};

DetailsContainer.propTypes = {
  log: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    log: state.logsData.currentLog,
    actions: PropTypes.object.isRequired
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({ loadLogAccordingToLogId, loadLogAccordingToCorrelationId }, dispatch),
    dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailsContainer);
